import React, {Component} from "react";
import {i18nInstance} from "../localization/core";

interface PropsContract {
  currentMenuItem: 'home' | 'history' | 'contact' | 'blog' | 'portfolio'
}

export default class NavBar extends Component<PropsContract> {

  handleChangeLocal(locale: string, event: any) {
    event.preventDefault()
    i18nInstance.changeLanguage(locale)
  }

  render() {
    return (
      <div className="art-menu-bar">

        {/* menu bar frame */}
        <div className="art-menu-bar-frame">

          {/* menu bar header */}
          <div className="art-menu-bar-header">
            {/* menu bar button */}
            <a className="art-menu-bar-btn" href="#.">
              {/* icon */}
              <span/>
            </a>
            {/* menu bar button end */}
          </div>
          {/* menu bar header end */}

          {/* current page title */}
          <div className="art-current-page"/>
          {/* current page title end */}

          {/* scroll frame */}
          <div className="art-scroll-frame">

            {/* menu */}
            <nav id="swupMenu">
              {/* menu list */}
              <ul className="main-menu">
                {/* menu item */}
                <li className={`menu-item ${this.props.currentMenuItem === 'home' ? 'current-menu-item' : ''}`}>
                  <a href="home.html">Home</a>
                </li>
                {/* menu item */}
                <li className={`menu-item menu-item-has-children ${this.props.currentMenuItem === 'portfolio' ? 'current-menu-item' : ''}`}>
                  <a href="#.">Portfolio</a>
                  {/* sub menu */}
                  <ul className="sub-menu">
                    {/* lvl 2 nav link */}
                    <li className="menu-item"><a href="portfolio-2-col.html">2 column</a></li>
                    {/* lvl 2 nav link */}
                    <li className="menu-item"><a href="portfolio-3-col.html">3 column</a></li>
                    {/* lvl 2 nav link */}
                    <li className="menu-item"><a href="portfolio-2-col-masonry.html">2 column masonry</a></li>
                    {/* lvl 2 nav link */}
                    <li className="menu-item"><a href="portfolio-3-col-masonry.html">3 column masonry</a></li>
                    {/* lvl 2 nav link */}
                    <li className="menu-item"><a href="portfolio-single.html">Single project</a></li>
                    {/* lvl 2 nav link */}
                    <li className="menu-item"><a href="portfolio-single-2.html">Single project 2</a></li>
                  </ul>
                  {/* sub menu end */}
                </li>
                {/* menu item */}
                <li className={`menu-item ${this.props.currentMenuItem === 'history' ? 'current-menu-item' : ''}`}>
                  <a href="history.html">History</a>
                </li>
                {/* menu item */}
                <li className={`menu-item ${this.props.currentMenuItem === 'contact' ? 'current-menu-item' : ''}`}>
                  <a href="contact.html">Contact</a>
                </li>
                {/* menu item */}
                <li className={`menu-item menu-item-has-children ${this.props.currentMenuItem === 'blog' ? 'current-menu-item' : ''}`}>
                  <a href="#.">Blog</a>
                  {/* sub menu */}
                  <ul className="sub-menu">
                    {/* lvl 2 nav link */}
                    <li className="menu-item"><a href="blog-2-col.html">2 column</a></li>
                    {/* lvl 2 nav link */}
                    <li className="menu-item"><a href="blog-3-col.html">3 column</a></li>
                    {/* lvl 2 nav link */}
                    <li className="menu-item"><a href="blog-post.html">Publication</a></li>
                  </ul>
                  {/* sub menu end */}
                </li>
                {/* menu item */}
                {/*<li className={`menu-item ${this.props.currentMenuItem === 'onepage' ? 'current-menu-item' : ''}`}>
                  <a href="onepage.html" target="_blank">Onepage</a>
                </li>*/}
              </ul>
              {/* menu list end */}
            </nav>
            {/* menu end */}

            {/* language change */}
            <ul className="art-language-change">
              {/* language item */}
              <li className={i18nInstance.language === 'fr' ? 'art-active-lang' : ''}>
                <a
                  href="#"
                  /* @ts-ignore */
                  onClick={this.handleChangeLocal.bind(this, 'fr')}
                >
                  FR
                </a>
              </li>
              {/* language item */}
              <li className={i18nInstance.language === 'en' ? 'art-active-lang' : ''}>
                <a
                  href="#"
                  /* @ts-ignore */
                  onClick={this.handleChangeLocal.bind(this, 'en')}
                >
                  EN
                </a>
              </li>
            </ul>
            {/* language change end */}

          </div>
          {/* scroll frame end */}

        </div>
        {/* menu bar frame */}

      </div>
    )
  }
}
